import React, { useEffect, useState } from "react";

import { AnimatePresence, motion } from 'framer-motion';
import MenuSVGIcon from '../../assets/images/svg-icons/menu.svg';
import {
  Link,
  Redirect,
  useLocation
} from "react-router-dom";
import useOnclickOutside from "react-cool-onclickoutside";
import { useSelector } from 'react-redux';
import permissions from "../../store/modules/permissions/reducer";
import { FaDollarSign } from 'react-icons/fa';
import { SiMicrostrategy } from 'react-icons/si'
import api from '../../services/api';
import { BiChevronDown } from  'react-icons/bi'

function MenuItem(props){

    const location = useLocation();

    const animation = {
        in: order => ({
            opacity: props.unable ? 0.3 : 1,
            x: 0,
            transition: { type: 'linear', delay: order * 0.1 },
        }),
        out: order => ({
            opacity: 0,
            x: -50,
            transition: { type: 'linear', delay: order * 0.1 },
        }),
    }

    return (
        <motion.li
            initial="out"
            animate="in"
            exit="out"
            variants={animation}
            custom={props.order} 
            className={(location.pathname == props.pathname || location.pathname == props.pathname2) ? "c-sidebar-nav-item c-sidebar-nav-item-active" : "c-sidebar-nav-item"}
            whileTap={{ scale: 0.95 }}
        >
                <Link to={props.pathname} className="c-sidebar-nav-link">
                    {props.icon}
                    {props.name}
                    {
                        props.unable &&
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15.167" viewBox="0 0 13 15.167" className="ml-3 locked">
                            <path id="Icon_open-lock-locked" data-name="Icon open-lock-locked" d="M6.5,0A4.346,4.346,0,0,0,2.167,4.333V6.5H0v8.667H13V6.5H10.833V4.333A4.346,4.346,0,0,0,6.5,0Zm0,2.167A2.146,2.146,0,0,1,8.667,4.333V6.5H4.333V4.333A2.146,2.146,0,0,1,6.5,2.167Z" opacity="0.5"/>
                        </svg>
                    }
                </Link>
        </motion.li>
    )

}

function Dropdown(props){

    const location = useLocation();

    const animation = {
        in: order => ({
            opacity: props.unable ? 0.3 : 1,
            x: 0,
            transition: { type: 'linear', delay: order * 0.1 },
        }),
        out: order => ({
            opacity: 0,
            x: -50,
            transition: { type: 'linear', delay: order * 0.1 },
        }),
    }

    const [opened, setOpened] = useState(false);

    const chevronAnimation = {
        opened: {
            rotate: 180,
            transition: { type: 'linear' },
            y: '-50%'
        },
        closed: {
            rotate: 0,
            transition: { type: 'linear' },
            y: '-50%'
        },
    }

    const itemAnimation = {
        opened: {
            opacity: 1,
            transition: { type: 'linear' },
            x: 0
        },
        closed: {
            opacity: 1,
            transition: { type: 'linear' },
            x: -20
        },
    }

    return (
        <motion.li
            className={"c-sidebar-nav-item c-sidebar-dropdown"}
        >
            <motion.div
                initial="out"
                animate="in"
                exit="out"
                variants={animation}
                custom={props.order} 
                whileTap={{ scale: 0.95 }}
                onClick={() => setOpened(!opened)}
                className="c-sidebar-nav-item c-sidebar-dropdown-item"
            >
                <span className="c-sidebar-nav-link">
                    {props.icon}
                    {props.name}
                    {
                        props.unable &&
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15.167" viewBox="0 0 13 15.167" className="ml-3 locked">
                            <path id="Icon_open-lock-locked" data-name="Icon open-lock-locked" d="M6.5,0A4.346,4.346,0,0,0,2.167,4.333V6.5H0v8.667H13V6.5H10.833V4.333A4.346,4.346,0,0,0,6.5,0Zm0,2.167A2.146,2.146,0,0,1,8.667,4.333V6.5H4.333V4.333A2.146,2.146,0,0,1,6.5,2.167Z" opacity="0.5"/>
                        </svg>
                    }
                    <motion.span 
                        className="chevron"
                        animate={opened ? 'opened' : 'closed'}
                        variants={chevronAnimation}
                    >
                        <BiChevronDown/>
                    </motion.span>
                </span>

            </motion.div>
            {
                opened &&
                <>
                    {
                        props.links.map(link => (
                            <Link to={link.pathname}>
                                <motion.li
                                    key={link.pathname}
                                    className={(location.pathname == link.pathname || location.pathname == link.pathname2) ? 
                                        "c-sidebar-nav-item c-sidebar-nav-item-active c-sidebar-nav-item-small" : 
                                        "c-sidebar-nav-item c-sidebar-nav-item-small"}
                                    style={{opacity: link.unable ? 0.3 : 1}}
                                >
                                    <span className="c-sidebar-nav-link c-sidebar-nav-link-small">
                                        {link.icon}
                                        {link.name}
                                        {
                                            link.unable &&
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15.167" viewBox="0 0 13 15.167" className="ml-3 locked">
                                                <path id="Icon_open-lock-locked" data-name="Icon open-lock-locked" d="M6.5,0A4.346,4.346,0,0,0,2.167,4.333V6.5H0v8.667H13V6.5H10.833V4.333A4.346,4.346,0,0,0,6.5,0Zm0,2.167A2.146,2.146,0,0,1,8.667,4.333V6.5H4.333V4.333A2.146,2.146,0,0,1,6.5,2.167Z" opacity="0.5"/>
                                            </svg>
                                        }
                                    </span>
                                </motion.li>
                            </Link>
                        ))
                    }
                </>
            }
        </motion.li>
    )

}

export default function Component({openMenu, setOpenMenu}) {
    
    const token = useSelector(state => state.auth.token);

    const [redirect, setRedirect] = useState(false);
  
    useEffect(() => {
      if(token){
        api.post(api.defaults.baseURL + '/application/role/' + token).then(res => {
          console.log(res);
          if(res){
            if(res.data.role == '6'){
              setRedirect(true);
            } else {
              setRedirect(false);
            }
          }
        });
      }
    }, [token])

    const toggleMenuAnimation = {
        in: {
            opacity: 1,
            x: 0,
            transition: 'linear',
            duration: 1,
        },
        out: {
            opacity: 0,
            x: -350,
            transition: 'linear',
            duration: 1,
        },
    }

    const backdropAnimation = {
        in: {
            opacity: 1,
            transition: 'linear',
            duration: 1,
        },
        out: {
            opacity: 0,
            transition: 'linear',
            duration: 1,
        },
    }

    const logoAnimation = {
        in: {
            opacity: 1,
            transition: 'linear',
            duration: 1,
        },
        out: {
            opacity: 0,
            transition: 'linear',
            duration: 1,
        },
    }

    const [mobile, setMobile] = useState(false);

    useEffect(() => {
        var x = window.matchMedia("(max-width: 768px)")
        checkWindowWidth(x)
        x.addListener(checkWindowWidth)
    }, []);

    function checkWindowWidth(x) {
        if (x.matches) {
            setOpenMenu(false);
            setMobile(true);
        } else {
            setOpenMenu(true);
            setMobile(false)
        }
    }

    const ref = useOnclickOutside(() => {
        if(mobile)
            setOpenMenu(false);
    });

    const logo = useSelector(state => state.data.logo);
    const permissions = useSelector(state => state.permissions);

    const [archivingLinks, setArchivingLinks] = useState([])
    const [strategyLinks, setStrategyLinks] = useState([])
    const [toolsLinks, setToolsLinks] = useState([])
    const [accountLinks, setAccountLinks] = useState([])
    const [settingsLinks, setSettingsLinks] = useState([])

    useEffect(() => {
        let archiving = []
        let strategy = []
        let tools = []
        let account = []
        let settings = []

        if(permissions.social_vault){
            archiving.push({
                pathname: '/dashboard/social-media-archiving',
                icon: 
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.995" height="19.288" viewBox="0 0 18.995 19.288" className="c-sidebar-nav-icon">
                        <g id="Group_240" data-name="Group 240" transform="translate(-55.022 -909.865)">
                        <g id="Icon_ionic-ios-folder-open" data-name="Icon ionic-ios-folder-open" transform="translate(55.022 909.865)">
                            <path id="Path_3" data-name="Path 3" d="M20.785,6.833a.935.935,0,0,0-.967-.975h-8.24a.314.314,0,0,1-.259-.1L10.365,4.8l-.008-.008A.922.922,0,0,0,9.623,4.5H5.548A1.009,1.009,0,0,0,4.5,5.475v3.1H20.785Z" transform="translate(-3.144 -4.5)"/>
                            <path id="Path_4" data-name="Path 4" d="M3.608,13.219H3.256c-.543,0-1.073.216-1,1.031s1,8.936,1,8.936c.115.755.5,1.06,1.06,1.06H19.265c.539,0,.891-.331.975-1.06,0,0,.941-7.842,1-8.715s-.377-1.251-1-1.251H3.608Z" transform="translate(-2.252 -7.96)"/>
                        </g>
                        <g id="Icon_awesome-long-arrow-alt-down" data-name="Icon awesome-long-arrow-alt-down" transform="translate(65.207 916.734)">
                            <path d="M 3.414539575576782 12.01926422119141 C 3.18213963508606 12.01926422119141 2.96364951133728 11.92876434326172 2.799319505691528 11.76442432403564 L 1.113839507102966 10.07894420623779 C 0.8641195893287659 9.829214096069336 0.790099561214447 9.457034111022949 0.9252495765686035 9.130764007568359 C 1.060399532318115 8.80450439453125 1.375909566879272 8.593684196472168 1.72905957698822 8.593684196472168 L 2.231858491897583 8.593684196472168 L 2.239479541778564 4.418973922729492 C 2.239479541778564 4.072198390960693 2.520047664642334 3.789000272750854 2.866554498672485 3.784733295440674 L 3.958799600601196 3.750704050064087 L 3.96502947807312 3.750514030456543 L 3.971259593963623 3.750514030456543 C 4.310959339141846 3.750514030456543 4.597949504852295 4.056963920593262 4.597949504852295 4.419703960418701 L 4.597949504852295 8.593684196472168 L 5.09999942779541 8.593684196472168 C 5.453149795532227 8.593684196472168 5.768669605255127 8.80450439453125 5.903819561004639 9.130784034729004 C 6.038959503173828 9.457054138183594 5.964939594268799 9.82923412322998 5.715219497680664 10.07894420623779 L 4.029739379882813 11.76442432403564 C 3.865429639816284 11.92875385284424 3.646939516067505 12.01926422119141 3.414539575576782 12.01926422119141 Z" stroke="none"/>
                            <path d="M 3.414536952972412 11.61926174163818 C 3.534832000732422 11.61926174163818 3.655124664306641 11.57336902618408 3.746899604797363 11.48158359527588 L 5.432379722595215 9.796104431152344 C 5.728479385375977 9.500003814697266 5.51876974105835 8.993683815002441 5.09999942779541 8.993683815002441 L 4.197949409484863 8.993683815002441 L 4.197949409484863 4.419703960418701 C 4.197949409484863 4.289914131164551 4.101059436798096 4.150514125823975 3.971259593963623 4.150514125823975 L 2.874499559402466 4.184684276580811 C 2.744709491729736 4.184684276580811 2.639479637145996 4.289914131164551 2.639479637145996 4.419703960418701 L 2.631129503250122 8.993683815002441 L 1.72905957698822 8.993683815002441 C 1.310289621353149 8.993683815002441 1.100579619407654 9.499983787536621 1.396679520606995 9.796104431152344 L 3.082159519195557 11.48158359527588 C 3.173944473266602 11.57336902618408 3.294242143630981 11.61926174163818 3.414536952972412 11.61926174163818 M 3.414539575576782 12.41926383972168 C 3.075299501419067 12.41926383972168 2.756359577178955 12.28715419769287 2.516469478607178 12.04727363586426 L 0.8309895396232605 10.36179447174072 C 0.4664695560932159 9.997234344482422 0.3584095537662506 9.453944206237793 0.5556995868682861 8.977684020996094 C 0.752979576587677 8.501423835754395 1.213549613952637 8.193683624267578 1.72905957698822 8.193683624267578 L 1.832587361335754 8.193683624267578 L 1.839479565620422 4.418243885040283 C 1.839479565620422 3.854518413543701 2.294798135757446 3.393706321716309 2.857891082763672 3.384815454483032 L 3.946349620819092 3.350903987884521 L 3.958799600601196 3.350513935089111 L 3.971259593963623 3.350513935089111 C 4.537379741668701 3.350513935089111 4.997949600219727 3.830153942108154 4.997949600219727 4.419703960418701 L 4.997949600219727 8.193683624267578 L 5.09999942779541 8.193683624267578 C 5.615509510040283 8.193683624267578 6.076089382171631 8.501434326171875 6.273369789123535 8.977704048156738 C 6.470649719238281 9.453984260559082 6.362589359283447 9.99726390838623 5.998069763183594 10.36179447174072 L 4.312589645385742 12.04727363586426 C 4.072779655456543 12.28713417053223 3.753819465637207 12.41926383972168 3.414539575576782 12.41926383972168 Z" stroke="none" fill="#f5f6f9"/>
                        </g>
                        </g>
                    </svg>,
                name: 'S. M. Archiving',
                unable: redirect
            })
        }
        if(permissions.calendar){
            archiving.push({
                pathname: '/dashboard/calendars',
                icon:   <svg xmlns="http://www.w3.org/2000/svg" width="19.291" height="22.047" viewBox="0 0 19.291 22.047" className="c-sidebar-nav-icon">
                            <path id="calendar-icon" d="M0,19.98a2.067,2.067,0,0,0,2.067,2.067H17.224a2.067,2.067,0,0,0,2.067-2.067V8.268H0Zm13.779-8.44a.518.518,0,0,1,.517-.517h1.722a.518.518,0,0,1,.517.517v1.722a.518.518,0,0,1-.517.517H14.3a.518.518,0,0,1-.517-.517Zm0,5.512a.518.518,0,0,1,.517-.517h1.722a.518.518,0,0,1,.517.517v1.722a.518.518,0,0,1-.517.517H14.3a.518.518,0,0,1-.517-.517ZM8.268,11.54a.518.518,0,0,1,.517-.517h1.722a.518.518,0,0,1,.517.517v1.722a.518.518,0,0,1-.517.517H8.784a.518.518,0,0,1-.517-.517Zm0,5.512a.518.518,0,0,1,.517-.517h1.722a.518.518,0,0,1,.517.517v1.722a.518.518,0,0,1-.517.517H8.784a.518.518,0,0,1-.517-.517ZM2.756,11.54a.518.518,0,0,1,.517-.517H5a.518.518,0,0,1,.517.517v1.722A.518.518,0,0,1,5,13.779H3.273a.518.518,0,0,1-.517-.517Zm0,5.512a.518.518,0,0,1,.517-.517H5a.518.518,0,0,1,.517.517v1.722A.518.518,0,0,1,5,19.291H3.273a.518.518,0,0,1-.517-.517Zm14.468-14.3H15.157V.689A.691.691,0,0,0,14.468,0H13.09A.691.691,0,0,0,12.4.689V2.756H6.89V.689A.691.691,0,0,0,6.2,0H4.823a.691.691,0,0,0-.689.689V2.756H2.067A2.067,2.067,0,0,0,0,4.823V6.89H19.291V4.823A2.067,2.067,0,0,0,17.224,2.756Z"/>
                        </svg>,
                name: 'Archiving Calendar',
                unable: redirect
            })
        }
        if(permissions.kanban || permissions.kanban_client){
            strategy.push({
                pathname: '/dashboard/tasks',
                icon: 
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tasks" className="svg-inline--fa fa-tasks fa-w-16 c-sidebar-nav-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"></path></svg>
                ,
                name: 'Tasks',
                unable: redirect
            })
        }
        if(permissions.post_blog){
            strategy.push({
                pathname: '/dashboard/social-media-posts',
                icon:   <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="images" className="svg-inline--fa fa-images fa-w-18 c-sidebar-nav-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                            <path fill="currentColor" d="M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"></path>
                        </svg>,
                name: 'Social Media Posts',
                unable: redirect
            })
        }
        if(permissions.vault){
            tools.push({
                pathname: '/dashboard/my-drive',
                icon: <i class="fas fa-hdd c-sidebar-nav-icon"></i>,
                name: 'Drive',
                unable: redirect
            })
        }
        if(permissions.persona){
            tools.push({
                pathname: '/dashboard/persona-generator',
                icon: <i class="fas fa-user-circle c-sidebar-nav-icon"></i>,
                name: 'Persona Generator',
                unable: redirect
            })
        }
        if(permissions.client_profile){
            account.push({
                pathname: '/dashboard/profile',
                icon: <i className="fas fa-user c-sidebar-nav-icon"></i>,
                name: 'Profile',
            })
        }
        if(permissions.billing){
            account.push({
                pathname: '/dashboard/billing',
                icon: <i class="fas fa-dollar-sign c-sidebar-nav-icon"></i>,
                name: 'Billing',
            })
        }
        if(permissions.social_medias){
            settings.push({
                pathname: '/dashboard/social-medias',
                icon: <i className="fas fa-th c-sidebar-nav-icon"></i>,
                name: 'S. M. Accounts',
            })
        }
        if(permissions.users){
            settings.push({
                pathname: '/dashboard/users',
                icon:   <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="users" className="svg-inline--fa fa-users fa-w-20 c-sidebar-nav-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                            <path fill="currentColor" d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"></path>
                        </svg>,
                name: 'Users',
                unable: redirect
            })
        }
        if(permissions.services){
            settings.push({
                pathname: '/dashboard/add-ons',
                icon: <i class="fas fa-puzzle-piece c-sidebar-nav-icon"></i>,
                name: 'Add-ons',
                unable: redirect
            })
        }
        if(permissions.roles){
            settings.push({
                pathname: '/dashboard/roles',
                icon: <i class="fas fa-users-cog c-sidebar-nav-icon"></i>,
                name: 'User Roles',
                unable: redirect
            })
        }

        setArchivingLinks(archiving)
        setStrategyLinks(strategy)
        setToolsLinks(tools)
        setAccountLinks(account)
        setSettingsLinks(settings)
    }, [permissions])

    return (
        <>
        {
            (mobile && openMenu) &&
            <motion.div 
                initial="out"
                animate="in"
                exit="out"
                variants={backdropAnimation}
                className="menu-backdrop"></motion.div>
        }
        <motion.div 
            animate={openMenu ? 'in' : 'out'}
            variants={toggleMenuAnimation}
            className="c-sidebar c-sidebar-dark c-sidebar-fixed c-sidebar-lg-show" 
            id="sidebar"
            ref={ref}
        >
            <div className="c-sidebar-brand d-md-down-none px-3 mb-2 mt-3" style={{minHeight: 100}}>
                {
                    logo &&
                    <motion.img 
                        initial="out"
                        animate="in"
                        exit="out"
                        variants={logoAnimation} src={logo} id="companyLogo" className='img-fluid' style={{maxHeight: 100}}/>
                }
            </div>
            <motion.ul 
                className="c-sidebar-nav"
            >
                
                {
                    permissions.dashboard &&
                    <MenuItem 
                        pathname={'/dashboard'} 
                        name={'Home'} 
                        icon={
                            <i className="fas fa-home c-sidebar-nav-icon"></i>
                        }
                        order={1}
                    />
                }

                {
                    permissions.grid_pages &&
                    <MenuItem 
                        pathname={'/dashboard/pages'} 
                        name={'Social Web Pages'} 
                        icon={
                            <i className="fas fa-columns c-sidebar-nav-icon"></i>
                        }
                        order={8}
                        unable={redirect}
                    />
                }

                {
                    permissions.calendar &&
                    <MenuItem 
                        pathname={'/dashboard/calendars'} 
                        name={'Calendars'} 
                        icon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="19.291" height="22.047" viewBox="0 0 19.291 22.047" className="c-sidebar-nav-icon">
                                <path id="calendar-icon" d="M0,19.98a2.067,2.067,0,0,0,2.067,2.067H17.224a2.067,2.067,0,0,0,2.067-2.067V8.268H0Zm13.779-8.44a.518.518,0,0,1,.517-.517h1.722a.518.518,0,0,1,.517.517v1.722a.518.518,0,0,1-.517.517H14.3a.518.518,0,0,1-.517-.517Zm0,5.512a.518.518,0,0,1,.517-.517h1.722a.518.518,0,0,1,.517.517v1.722a.518.518,0,0,1-.517.517H14.3a.518.518,0,0,1-.517-.517ZM8.268,11.54a.518.518,0,0,1,.517-.517h1.722a.518.518,0,0,1,.517.517v1.722a.518.518,0,0,1-.517.517H8.784a.518.518,0,0,1-.517-.517Zm0,5.512a.518.518,0,0,1,.517-.517h1.722a.518.518,0,0,1,.517.517v1.722a.518.518,0,0,1-.517.517H8.784a.518.518,0,0,1-.517-.517ZM2.756,11.54a.518.518,0,0,1,.517-.517H5a.518.518,0,0,1,.517.517v1.722A.518.518,0,0,1,5,13.779H3.273a.518.518,0,0,1-.517-.517Zm0,5.512a.518.518,0,0,1,.517-.517H5a.518.518,0,0,1,.517.517v1.722A.518.518,0,0,1,5,19.291H3.273a.518.518,0,0,1-.517-.517Zm14.468-14.3H15.157V.689A.691.691,0,0,0,14.468,0H13.09A.691.691,0,0,0,12.4.689V2.756H6.89V.689A.691.691,0,0,0,6.2,0H4.823a.691.691,0,0,0-.689.689V2.756H2.067A2.067,2.067,0,0,0,0,4.823V6.89H19.291V4.823A2.067,2.067,0,0,0,17.224,2.756Z"/>
                            </svg>
                        }
                        order={5}
                        unable={redirect}
                    />
                }

                {
                    permissions.competitors &&
                    <MenuItem 
                        pathname={'/dashboard/competitors'} 
                        name={'Competitor Analysis'} 
                        icon={
                            <i className="fas fa-th c-sidebar-nav-icon"></i>
                        }
                        order={3}
                        unable={redirect}
                    />
                }

                {
                    permissions.user_leads &&
                    <MenuItem 
                        pathname={'/dashboard/leads'} 
                        name={'Social Media Leads'} 
                        icon={
                            <i className="fas fa-user-tag c-sidebar-nav-icon"></i>
                        }
                        order={7}
                        unable={redirect}
                    />
                }
                
                {
                    (archivingLinks.length > 0) &&
                    <Dropdown 
                        name={'Archiving'} 
                        icon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="18.995" height="19.288" viewBox="0 0 18.995 19.288" className="c-sidebar-nav-icon">
                                <g id="Group_240" data-name="Group 240" transform="translate(-55.022 -909.865)">
                                <g id="Icon_ionic-ios-folder-open" data-name="Icon ionic-ios-folder-open" transform="translate(55.022 909.865)">
                                    <path id="Path_3" data-name="Path 3" d="M20.785,6.833a.935.935,0,0,0-.967-.975h-8.24a.314.314,0,0,1-.259-.1L10.365,4.8l-.008-.008A.922.922,0,0,0,9.623,4.5H5.548A1.009,1.009,0,0,0,4.5,5.475v3.1H20.785Z" transform="translate(-3.144 -4.5)"/>
                                    <path id="Path_4" data-name="Path 4" d="M3.608,13.219H3.256c-.543,0-1.073.216-1,1.031s1,8.936,1,8.936c.115.755.5,1.06,1.06,1.06H19.265c.539,0,.891-.331.975-1.06,0,0,.941-7.842,1-8.715s-.377-1.251-1-1.251H3.608Z" transform="translate(-2.252 -7.96)"/>
                                </g>
                                <g id="Icon_awesome-long-arrow-alt-down" data-name="Icon awesome-long-arrow-alt-down" transform="translate(65.207 916.734)">
                                    <path d="M 3.414539575576782 12.01926422119141 C 3.18213963508606 12.01926422119141 2.96364951133728 11.92876434326172 2.799319505691528 11.76442432403564 L 1.113839507102966 10.07894420623779 C 0.8641195893287659 9.829214096069336 0.790099561214447 9.457034111022949 0.9252495765686035 9.130764007568359 C 1.060399532318115 8.80450439453125 1.375909566879272 8.593684196472168 1.72905957698822 8.593684196472168 L 2.231858491897583 8.593684196472168 L 2.239479541778564 4.418973922729492 C 2.239479541778564 4.072198390960693 2.520047664642334 3.789000272750854 2.866554498672485 3.784733295440674 L 3.958799600601196 3.750704050064087 L 3.96502947807312 3.750514030456543 L 3.971259593963623 3.750514030456543 C 4.310959339141846 3.750514030456543 4.597949504852295 4.056963920593262 4.597949504852295 4.419703960418701 L 4.597949504852295 8.593684196472168 L 5.09999942779541 8.593684196472168 C 5.453149795532227 8.593684196472168 5.768669605255127 8.80450439453125 5.903819561004639 9.130784034729004 C 6.038959503173828 9.457054138183594 5.964939594268799 9.82923412322998 5.715219497680664 10.07894420623779 L 4.029739379882813 11.76442432403564 C 3.865429639816284 11.92875385284424 3.646939516067505 12.01926422119141 3.414539575576782 12.01926422119141 Z" stroke="none"/>
                                    <path d="M 3.414536952972412 11.61926174163818 C 3.534832000732422 11.61926174163818 3.655124664306641 11.57336902618408 3.746899604797363 11.48158359527588 L 5.432379722595215 9.796104431152344 C 5.728479385375977 9.500003814697266 5.51876974105835 8.993683815002441 5.09999942779541 8.993683815002441 L 4.197949409484863 8.993683815002441 L 4.197949409484863 4.419703960418701 C 4.197949409484863 4.289914131164551 4.101059436798096 4.150514125823975 3.971259593963623 4.150514125823975 L 2.874499559402466 4.184684276580811 C 2.744709491729736 4.184684276580811 2.639479637145996 4.289914131164551 2.639479637145996 4.419703960418701 L 2.631129503250122 8.993683815002441 L 1.72905957698822 8.993683815002441 C 1.310289621353149 8.993683815002441 1.100579619407654 9.499983787536621 1.396679520606995 9.796104431152344 L 3.082159519195557 11.48158359527588 C 3.173944473266602 11.57336902618408 3.294242143630981 11.61926174163818 3.414536952972412 11.61926174163818 M 3.414539575576782 12.41926383972168 C 3.075299501419067 12.41926383972168 2.756359577178955 12.28715419769287 2.516469478607178 12.04727363586426 L 0.8309895396232605 10.36179447174072 C 0.4664695560932159 9.997234344482422 0.3584095537662506 9.453944206237793 0.5556995868682861 8.977684020996094 C 0.752979576587677 8.501423835754395 1.213549613952637 8.193683624267578 1.72905957698822 8.193683624267578 L 1.832587361335754 8.193683624267578 L 1.839479565620422 4.418243885040283 C 1.839479565620422 3.854518413543701 2.294798135757446 3.393706321716309 2.857891082763672 3.384815454483032 L 3.946349620819092 3.350903987884521 L 3.958799600601196 3.350513935089111 L 3.971259593963623 3.350513935089111 C 4.537379741668701 3.350513935089111 4.997949600219727 3.830153942108154 4.997949600219727 4.419703960418701 L 4.997949600219727 8.193683624267578 L 5.09999942779541 8.193683624267578 C 5.615509510040283 8.193683624267578 6.076089382171631 8.501434326171875 6.273369789123535 8.977704048156738 C 6.470649719238281 9.453984260559082 6.362589359283447 9.99726390838623 5.998069763183594 10.36179447174072 L 4.312589645385742 12.04727363586426 C 4.072779655456543 12.28713417053223 3.753819465637207 12.41926383972168 3.414539575576782 12.41926383972168 Z" stroke="none" fill="#f5f6f9"/>
                                </g>
                                </g>
                            </svg>
                        }
                        order={1}
                        links={archivingLinks}
                    />
                }
                
                {
                    (strategyLinks.length > 0) &&
                    <Dropdown 
                        name={'Digital Strategy'} 
                        icon={
                            <i className="fas fa-project-diagram c-sidebar-nav-icon"></i>
                        }
                        order={1}
                        links={strategyLinks}
                    />
                }
                
                {
                    (toolsLinks.length > 0) &&
                    <Dropdown 
                        name={'Tools'} 
                        icon={
                            <i className="fas fa-tools c-sidebar-nav-icon"></i>
                        }
                        order={1}
                        links={toolsLinks}
                    />
                }
                
                {
                    (accountLinks.length > 0) &&
                    <Dropdown 
                        name={'My Account'} 
                        icon={
                            <i className="fas fa-user c-sidebar-nav-icon"></i>
                        }
                        order={1}
                        links={accountLinks}
                    />
                }
                
                {
                    (settingsLinks.length > 0) &&
                    <Dropdown 
                        name={'Settings'} 
                        icon={
                            <i class="fas fa-cog c-sidebar-nav-icon"></i>
                        }
                        order={1}
                        links={settingsLinks}
                    />
                }

                {
                    /*
                        {
                            permissions.client_profile &&
                            <MenuItem 
                                pathname={'/dashboard/profile'} 
                                name={'Profile'} 
                                icon={
                                    <i className="fas fa-user c-sidebar-nav-icon"></i>
                                }
                                order={2}
                            />
                        }

                        {
                            permissions.social_medias &&
                            <MenuItem 
                                pathname={'/dashboard/social-medias'} 
                                name={'Social Medias'} 
                                icon={
                                    <i className="fas fa-th c-sidebar-nav-icon"></i>
                                }
                                order={3}
                            />
                        }

                        {
                            permissions.social_vault &&
                            <MenuItem 
                                pathname={'/dashboard/social-media-archiving'} 
                                name={'Social Media Archiving'} 
                                icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18.995" height="19.288" viewBox="0 0 18.995 19.288" className="c-sidebar-nav-icon">
                                        <g id="Group_240" data-name="Group 240" transform="translate(-55.022 -909.865)">
                                        <g id="Icon_ionic-ios-folder-open" data-name="Icon ionic-ios-folder-open" transform="translate(55.022 909.865)">
                                            <path id="Path_3" data-name="Path 3" d="M20.785,6.833a.935.935,0,0,0-.967-.975h-8.24a.314.314,0,0,1-.259-.1L10.365,4.8l-.008-.008A.922.922,0,0,0,9.623,4.5H5.548A1.009,1.009,0,0,0,4.5,5.475v3.1H20.785Z" transform="translate(-3.144 -4.5)"/>
                                            <path id="Path_4" data-name="Path 4" d="M3.608,13.219H3.256c-.543,0-1.073.216-1,1.031s1,8.936,1,8.936c.115.755.5,1.06,1.06,1.06H19.265c.539,0,.891-.331.975-1.06,0,0,.941-7.842,1-8.715s-.377-1.251-1-1.251H3.608Z" transform="translate(-2.252 -7.96)"/>
                                        </g>
                                        <g id="Icon_awesome-long-arrow-alt-down" data-name="Icon awesome-long-arrow-alt-down" transform="translate(65.207 916.734)">
                                            <path d="M 3.414539575576782 12.01926422119141 C 3.18213963508606 12.01926422119141 2.96364951133728 11.92876434326172 2.799319505691528 11.76442432403564 L 1.113839507102966 10.07894420623779 C 0.8641195893287659 9.829214096069336 0.790099561214447 9.457034111022949 0.9252495765686035 9.130764007568359 C 1.060399532318115 8.80450439453125 1.375909566879272 8.593684196472168 1.72905957698822 8.593684196472168 L 2.231858491897583 8.593684196472168 L 2.239479541778564 4.418973922729492 C 2.239479541778564 4.072198390960693 2.520047664642334 3.789000272750854 2.866554498672485 3.784733295440674 L 3.958799600601196 3.750704050064087 L 3.96502947807312 3.750514030456543 L 3.971259593963623 3.750514030456543 C 4.310959339141846 3.750514030456543 4.597949504852295 4.056963920593262 4.597949504852295 4.419703960418701 L 4.597949504852295 8.593684196472168 L 5.09999942779541 8.593684196472168 C 5.453149795532227 8.593684196472168 5.768669605255127 8.80450439453125 5.903819561004639 9.130784034729004 C 6.038959503173828 9.457054138183594 5.964939594268799 9.82923412322998 5.715219497680664 10.07894420623779 L 4.029739379882813 11.76442432403564 C 3.865429639816284 11.92875385284424 3.646939516067505 12.01926422119141 3.414539575576782 12.01926422119141 Z" stroke="none"/>
                                            <path d="M 3.414536952972412 11.61926174163818 C 3.534832000732422 11.61926174163818 3.655124664306641 11.57336902618408 3.746899604797363 11.48158359527588 L 5.432379722595215 9.796104431152344 C 5.728479385375977 9.500003814697266 5.51876974105835 8.993683815002441 5.09999942779541 8.993683815002441 L 4.197949409484863 8.993683815002441 L 4.197949409484863 4.419703960418701 C 4.197949409484863 4.289914131164551 4.101059436798096 4.150514125823975 3.971259593963623 4.150514125823975 L 2.874499559402466 4.184684276580811 C 2.744709491729736 4.184684276580811 2.639479637145996 4.289914131164551 2.639479637145996 4.419703960418701 L 2.631129503250122 8.993683815002441 L 1.72905957698822 8.993683815002441 C 1.310289621353149 8.993683815002441 1.100579619407654 9.499983787536621 1.396679520606995 9.796104431152344 L 3.082159519195557 11.48158359527588 C 3.173944473266602 11.57336902618408 3.294242143630981 11.61926174163818 3.414536952972412 11.61926174163818 M 3.414539575576782 12.41926383972168 C 3.075299501419067 12.41926383972168 2.756359577178955 12.28715419769287 2.516469478607178 12.04727363586426 L 0.8309895396232605 10.36179447174072 C 0.4664695560932159 9.997234344482422 0.3584095537662506 9.453944206237793 0.5556995868682861 8.977684020996094 C 0.752979576587677 8.501423835754395 1.213549613952637 8.193683624267578 1.72905957698822 8.193683624267578 L 1.832587361335754 8.193683624267578 L 1.839479565620422 4.418243885040283 C 1.839479565620422 3.854518413543701 2.294798135757446 3.393706321716309 2.857891082763672 3.384815454483032 L 3.946349620819092 3.350903987884521 L 3.958799600601196 3.350513935089111 L 3.971259593963623 3.350513935089111 C 4.537379741668701 3.350513935089111 4.997949600219727 3.830153942108154 4.997949600219727 4.419703960418701 L 4.997949600219727 8.193683624267578 L 5.09999942779541 8.193683624267578 C 5.615509510040283 8.193683624267578 6.076089382171631 8.501434326171875 6.273369789123535 8.977704048156738 C 6.470649719238281 9.453984260559082 6.362589359283447 9.99726390838623 5.998069763183594 10.36179447174072 L 4.312589645385742 12.04727363586426 C 4.072779655456543 12.28713417053223 3.753819465637207 12.41926383972168 3.414539575576782 12.41926383972168 Z" stroke="none" fill="#f5f6f9"/>
                                        </g>
                                        </g>
                                    </svg>
                                }
                                order={4}
                            />
                        }

                        {
                            permissions.kanban_client &&
                            <MenuItem 
                                pathname={'/dashboard/tasks'} 
                                pathname2={'/dashboard/tasks/kanban'} 
                                name={'Tasks'} 
                                icon={
                                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tasks" className="svg-inline--fa fa-tasks fa-w-16 c-sidebar-nav-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"></path></svg>
                                }
                                order={3}
                                unable={redirect}
                            />
                        }

                        {
                            permissions.post_blog &&
                            <MenuItem 
                                pathname={'/dashboard/social-media-posts'} 
                                name={'Social Media Posts'} 
                                icon={
                                    
                                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="images" className="svg-inline--fa fa-images fa-w-18 c-sidebar-nav-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                        <path fill="currentColor" d="M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"></path>
                                    </svg>
                                }
                                order={6}
                                unable={redirect}
                            />
                        }

                        {
                            permissions.client_user &&
                            <MenuItem 
                                pathname={'/dashboard/users'} 
                                name={'Users'} 
                                icon={
                                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="users" className="svg-inline--fa fa-users fa-w-20 c-sidebar-nav-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                        <path fill="currentColor" d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"></path>
                                    </svg>
                                }
                                order={6}
                                unable={redirect}
                            />
                        }

                        {
                            permissions.vault &&
                            <MenuItem 
                                pathname={'/dashboard/my-drive'} 
                                name={'My Drive'} 
                                icon={
                                    <i class="fas fa-hdd c-sidebar-nav-icon"></i>
                                }
                                order={8}
                                unable={redirect}
                            />
                        }

                        {
                            true &&
                            <MenuItem 
                                pathname={'/dashboard/add-ons'} 
                                name={'Add-ons'} 
                                icon={
                                    <i class="fas fa-puzzle-piece c-sidebar-nav-icon"></i>
                                }
                                order={8}
                            />
                        }

                        {
                            true &&
                            <MenuItem 
                                pathname={'/dashboard/roles'} 
                                name={'Roles'} 
                                icon={
                                    <i class="fas fa-users-cog c-sidebar-nav-icon"></i>
                                }
                                order={8}
                            />
                        }

                        {
                            true &&
                            <MenuItem 
                                pathname={'/dashboard/billing'} 
                                name={'Billing Details'} 
                                icon={
                                    <i class="fas fa-dollar-sign c-sidebar-nav-icon"></i>
                                }
                                order={8}
                            />
                        }

                        {
                            true &&
                            <MenuItem 
                                pathname={'/dashboard/persona-generator'} 
                                name={'Persona Generator'} 
                                icon={
                                    <i class="fas fa-user-circle c-sidebar-nav-icon"></i>
                                }
                                order={8}
                            />
                        }
                    */
                }
            </motion.ul>
        </motion.div>
        </>
    );
}